module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_TCA_image_3.77d1d72e.png";